module.exports = __webpack_public_path__ + "img/400.2a8e3e38.svg";